import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * WS-1063 Миграция файлов из Telegram для Desktop
 */
export const cloudFilesMigrationDesktop = getFeature('cloud-files-migration-desktop');

/**
 * CLOUDWEB-20682: [tgmig] Входные точки в миграцию на десктопе. Блок в сайдбаре
 */
export const cloudFilesMigrationDesktopSidebarLink =
    getFeature('cloud-files-migration-desktop-sidebar-link') || '/files_migration?from_app=cloud&enter_point=sider';
